import * as React from 'react';
import type { ClassNameMap } from './types';
import { cn } from '@utils';

interface FlexWrapProps {
	children: React.ReactNode;
	containerClassName?: string;
	allItemClassName?: string;
	itemsClasses?: ClassNameMap;
}

export const FlexWrapLayout: React.FC<FlexWrapProps> = ({
	children,
	containerClassName,
	allItemClassName,
	itemsClasses = {},
}) => {
	return (
		<div className={cn(`flex w-full flex-wrap gap-4`, containerClassName)}>
			{React.Children.map(children, (child, index) => (
				<div
					className={cn(
						`shrink grow basis-full md:basis-[45%]`,
						allItemClassName,
						itemsClasses[index]?.className || ''
					)}
				>
					{child}
				</div>
			))}
		</div>
	);
};
